/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReferenceMetricsDTO } from './referenceMetricsDTO';


export interface GeoCampaignListingRequestDTO { 
    clientId: number;
    brandId: number;
    conversionTypeIds: Array<number>;
    tactics: Array<string>;
    vendor: string;
    referencePeriodStartDate: number;
    referencePeriodEndDate: number;
    studyStartDate?: number;
    studyEndDate?: number;
    geoSplitType?: string;
    testType?: GeoCampaignListingRequestDTO.TestTypeEnum;
    scaleCost?: number;
    testDurationInDays?: number;
    referenceMetrics?: ReferenceMetricsDTO;
    dsMdlSimulationId?: number;
    isSupportedBySyncTool?: boolean;
    userSelectedInventory?: Array<string>;
    cellSize?: number;
    accountTypes?: Array<string>;
}
export namespace GeoCampaignListingRequestDTO {
    export type TestTypeEnum = 'Holdout' | 'Scale' | 'Contribution';
    export const TestTypeEnum = {
        Holdout: 'Holdout' as TestTypeEnum,
        Scale: 'Scale' as TestTypeEnum,
        Contribution: 'Contribution' as TestTypeEnum
    };
}


